export default "__VITE_ASSET__cab7672b__"